import { ILog } from "@ihr-radioedit/inferno-core";

const log = ILog.logger("OneTrustLib");

declare global {
  type OneTrustDataLayer = {
    event: "OneTrustLoaded" | "OneTrustGroupsUpdated" | "OptanonLoaded";
    OnetrustActiveGroups: string;
  };
  interface Window {
    dataLayer: OneTrustDataLayer[];
  }
}

export const getOneTrustActiveGroupsStatus = () => {
  const oneTrustEvent = "onetrustloaded";
  const oneTrustActiveGroupsStatus = window.dataLayer
    ?.find(dl => dl.event?.toLowerCase() === oneTrustEvent)
    ?.OnetrustActiveGroups?.toLowerCase();

  if (!oneTrustActiveGroupsStatus) {
    log.debug("OneTrust active groups status not found");
  }

  return oneTrustActiveGroupsStatus;
};

export const isOneTrustOptIn = (groupStatus: string) => {
  const oneTrustOptIn = "c0004";
  return groupStatus.includes(oneTrustOptIn);
};
